import React, { useState } from 'react';
import { cardFillSchema } from 'libs/schemas';

export const useCardForm = () => {
  const formRef = React.useRef(null);
  const [formValues, setFormValues] = useState({
    card_number: '',
    expiry_date: '',
    cvv2: '',
  });
  const [errors, setErrors] = useState({});

  const setFormValue = async (name, value) => {
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));

    try {
      await cardFillSchema.validateAt(name, { ...formValues, [name]: value });
      setErrors((prev) => ({ ...prev, [name]: undefined }));
    } catch (err) {
      setErrors((prev) => ({ ...prev, [name]: err.message }));
    }
  };

  const sendForm = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    cardFillSchema
      .validate(formValues, { abortEarly: false })
      .then(() => {
        formRef.current.requestSubmit();
      })
      .catch((errors) => setErrors(errors.inner.reduce((acc, error) => ({ ...acc, [error.path]: error.message }), {})));
  };

  return { formRef, formValues, setFormValue, errors, sendForm };
};
